<ng-template #settingsPanelPortal>
    <div
        class="settings-panel"
        [@fade]="'in'"
        spClickOutside
        (clickOutside)="closePanel()"
        [style.transform]="panelTransform()"
    >
        <div class="animation-wrapper">
            <!--
                Keyed on the selection: the panel outlives it, so a settings
                component has to be rebuilt when the selection moves.
            -->
            @for (key of selectionKey(); track key) {
                @switch (entityType()) {
                    @case (ESelectedEntityType.theme) {
                        <web-theme-settings />
                    }
                    @case (ESelectedEntityType.block) {
                        <web-block-settings [entity]="$any(selectedBlock())" />
                    }
                    @case (ESelectedEntityType.specificBlock) {
                        <web-specific-block-settings [entity]="$any(selectedBlock())" />
                    }
                    @case (ESelectedEntityType.zeroBlock) {
                        <web-zero-block-settings [entity]="$any(selectedBlock())" />
                    }
                    @case (ESelectedEntityType.specificSection) {
                        <web-specific-section-settings [entity]="$any(selectedSection())" />
                    }
                    @case (ESelectedEntityType.column) {
                        <web-column-settings
                            [entity]="selectedColumn()"
                            [parentEntity]="$any(selectedSectionByColumnId())"
                        />
                    }
                    @case (ESelectedEntityType.grid) {
                        <web-grid-settings [entity]="selectedGrid()" />
                    }
                    @case (ESelectedEntityType.tab) {
                        <web-tab-settings [entity]="selectedTab()" />
                    }
                    @case (ESelectedEntityType.widget) {
                        <web-widget-settings [widget]="selectedWidget()" />
                    }
                }
            }
        </div>
    </div>
</ng-template>
